<template>
    <div id="app" :class="projectHost">
        <noscript v-if="gtmId != null"><iframe :src="'https://www.googletagmanager.com/ns.html?id=' + gtmId" height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
        <noscript v-if="yandexId != null"><div><img :src="'https://mc.yandex.ru/watch/' + yandexId" style="position:absolute; left:-9999px;" alt="" /></div></noscript>
        <vue-topprogress ref="topProgress" color="#7D7A7A" :minimum="70" :speed="450"></vue-topprogress>
        <div class="wrapper" v-if="colorIsSet && salesCard != null && salesCard.project_dev_init != null && salesCard.project_dev_init != 'true'">
            <div class="wrapper-in">
                <formLandModal v-if="isOpenFormLandModal"></formLandModal>
                <AppHeader></AppHeader>
                <burgerMenu></burgerMenu>
                <main class="content">
                    <home></home>
                </main>
                <AppFooter></AppFooter>
                <topBtn :class="{fadeIn: fadeInVisible}"></topBtn>
            </div>
        </div>
        <devPage v-if="salesCard != null && salesCard.project_dev_init != null && salesCard.project_dev_init == 'true'"></devPage>
        <testThemePage v-if="projectHost == 'test-theme'"></testThemePage>
        <setUpThemePage v-if="projectHost == 'setup-theme'"></setUpThemePage>
        <transition name="fade" mode="out-in">
            <div class="body-overlay" id="body-overlay" @click="closeMobileMenu(false)" v-cloak v-if="openSendwich || isOpenFormLandModal" :class="{'openFormLandModal' : isOpenFormLandModal}"></div>
        </transition>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { PROJECTS, resolveProjectKey } from '@/config/projects'
    import { initGtm, initYandex, initJivo } from '@/plugins/shablonScripts'
    // импорты компонентов опустил ради краткости
    import AppHeader from '@/components/header/header.vue'
    import AppFooter from '@/components/footer/footer.vue'
    import burgerMenu from '@/components/burger-menu/burger-menu.vue'
    import topBtn from '@/components/partials/topBtn.vue'
    import home from '@/views/home.vue'
    import devPage from '@/views/dev-page.vue'
    import testThemePage from '@/views/test-theme.vue'
    import setUpThemePage from '@/views/setup-theme.vue'
    import formLandModal from '@/components/forms/form-land-modal.vue'

    import CssFilterConverter from 'css-filter-converter';
    import cookie from 'vue-cookie'

    const raw = window.location.host || ''
    const key = resolveProjectKey(raw)
    const cfg = PROJECTS[key] || {}
    document.body.setAttribute('data-project', key)
    document.body.classList.add(key)

export default {
    components: {
        AppHeader,
        AppFooter,
        burgerMenu,
        home,
        devPage,
        testThemePage,
        setUpThemePage,
        topBtn,
        formLandModal,
    },

    data () {
        const meta = (cfg && cfg.meta) ? cfg.meta : {}
        return {
            projectHost: key,
            gtmId: cfg.gtm || '',
            yandexId: cfg.yandex || '',
            jivoId: cfg.jivo || '',
            // meta
            title: meta.title || '',
            contentDescription: meta.desc || '',
            keyWordsContent: meta.keywords || '',
            // прочее
            isMobile: false,
            colorIsSet: false,
            themeColorMain: null,
            DomLoaded: false,
            fadeInVisible: false,
            lang: window.GlobalLang
        }
    },

    metaInfo () {
        return {
            title: this.title || 'BAZIS-A COMPLEX',
            meta: [
                { name: 'description', content: this.contentDescription || '' },
                { name: 'keywords', content: this.keyWordsContent || '' }
            ]
        }
    },

    computed: mapGetters({
        salesCard: 'loadSalesCardContent',
        openSendwich: 'loadOpenSendwich',
        isMobileChecker: 'loadIsMobileChecker',
        isOpenFormLandModal: 'loadIsOpenFormLandModal',
    }),

    created () {
        this.$store.dispatch('getFlatsWordsData')
        this.$store.dispatch('getSalesCardContent', this.projectHost)
        window.addEventListener('scroll', this.handleScroll)
    },

    mounted () {
        initGtm(this.gtmId)
        initYandex(this.yandexId)
        initJivo(this.jivoId)
        //
        this.isMobileCheck();
        this.checkResize();
        this.$refs.topProgress.start();
        this.$store.watch(
            (state) => state.salesCardContent,
            (newValue) => {
                if (newValue != null) {
                    this.setBrandColor();
                    this.checkFormLandModal();
                    this.$refs.topProgress.done();
                    const hash = window.location.hash;
                    if (hash) {
                    // Подождём, чтобы DOM точно отрисовался
                        this.$nextTick(() => {
                            // Прокрутка к якорю через vue-scrollto
                            this.$scrollTo(hash, 0, {
                                offset: this.offsetResponse || 0 // если у тебя есть кастомный отступ
                            });
                        });
                    }
                }
            }
        )
    },

    beforeDestroy () {
        window.removeEventListener('scroll', this.handleScroll)
    },

  methods: {
    closeMobileMenu(data) {
        this.$store.commit('Open_Sendwich', data);
        document.getElementsByTagName('body')[0].classList.toggle('overlay-open');
        if (this.isOpenFormLandModal) {
            cookie.set(window.host + '_form_land_modal_timer', true, { expires: this.salesCard.project_shablon_fields.project_drop_modal_form.minutes + 'm' });
            this.$store.commit('Open_FormLandModal', false);
        }
    },
    setBrandColor() {
        // console.log(this.salesCard.project_shablon_fields.shablon_news_color, 'asdasdasdasdas')
        const resultBrandColor = CssFilterConverter.hexToFilter(this.salesCard.shablon_brand_color);
        const resultLogoBazisColor = CssFilterConverter.hexToFilter(this.salesCard.shablon_logo_bazis_color);
        document.body.style.setProperty('--shablon-color', this.salesCard.shablon_brand_color);
        document.body.style.setProperty('--shablon-plans-color', this.salesCard.shablon_plans_color);
        document.body.style.setProperty('--shablon-news-color', this.salesCard.shablon_news_color);
        document.body.style.setProperty('--shablon-logo-bazis-color', resultLogoBazisColor.color);
        document.body.style.setProperty('--shablon-pin-icon-filter-color', resultBrandColor.color);
        this.themeColorMain = this.salesCard.shablon_brand_color;
        this.colorIsSet = true;
        // console.log(result, 'asdasdasda')
    },
    checkFormLandModal() {
        if (this.salesCard != null) {
            if (this.salesCard.project_drop_modal_form != undefined && this.salesCard.project_drop_modal_form.init == 'true') {
                // console.log(this.salesCard, 'asdasdasdsa')
                const seconds = parseInt(this.salesCard.project_drop_modal_form.seconds) * 1000;
                var timerCockie = cookie.get(window.host + '_form_land_modal_timer');
                setTimeout(() => {
                    // console.log(seconds);
                    if (timerCockie == null) {
                        // console.log(seconds, 'SECONDS', timerCockie);
                        this.$store.commit('Open_FormLandModal', true);
                        document.getElementsByTagName('body')[0].classList.add('overlay-open');
                    } 
                    // else { // если кука есть какие то действия при необходимости
                    //     console.log(timerCockie, 'COCKIE TIMER');
                    // }
                }, seconds);
            } 
            // else {
            //     // console.log('FORM LAND MODAL IS FFFFFALLLLLLSEEEEE ')
            // }
        }

        // const tokenAuthCrm = cookie.get('crm_auth_token');
        // cookie.set('crm_auth_token', response.data.access_token, { expires: response.data.expires_in + 's' });
        // isOpenFormLandModal
        // Open_FormLandModal
    },
    // MOBILE CHECKER
    isMobileCheck() {
        if (window.innerWidth < 767) {
            this.iSmobile = true
            this.$store.commit('setMobileCheckerState', true);
            this.$store.commit('setOffsetResponse', -60);
        }
    },
    handleResize() {
        if (window.innerWidth < 767) {
            this.iSmobile = true
            this.$store.commit('setMobileCheckerState', true);
            this.$store.commit('setOffsetResponse', -60);
        } else {
            this.iSmobile = false
            this.$store.commit('setMobileCheckerState', false);
            this.$store.commit('setOffsetResponse', -100);
        }
    },
    checkResize() {
        window.addEventListener('resize', this.handleResize)
        this.handleResize();
    },
    handleScroll () {
        if (window.scrollY >= window.innerHeight - 600) {
            this.fadeInVisible = true;
        } else {
            this.fadeInVisible = false;
        }
    },
  }
}

</script>